import {
  ViewerType,
  viewerTypeToLocalStorageKey,
} from '../constant/viewerConstant';

export function saveViewerSettingToLocalStorage(
  viewerType: ViewerType,
  VIEWER_SETTING_KEY: string,
  data: string
) {
  window.localStorage.setItem(
    [viewerTypeToLocalStorageKey(viewerType), VIEWER_SETTING_KEY].join('_'),
    data
  );
}
